'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _reactCsv = require('react-csv');

var _map = require('lodash/fp/map');

var _map2 = _interopRequireDefault(_map);

var _uniq = require('lodash/fp/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

var _flow = require('lodash/fp/flow');

var _flow2 = _interopRequireDefault(_flow);

var _DayPickerInput = require('react-day-picker/DayPickerInput');

var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);

require('react-day-picker/lib/style.css');

var _moment3 = require('react-day-picker/moment');

var _paidReportSummary = require('./../paid-report-summary');

var _paidReportSummary2 = _interopRequireDefault(_paidReportSummary);

var _mobile = require('./../paid-report-summary/mobile');

var _mobile2 = _interopRequireDefault(_mobile);

var _paidReportHeader = require('./../paid-report-header');

var _paidReportHeader2 = _interopRequireDefault(_paidReportHeader);

var _paidReportRow = require('./../paid-report-row');

var _paidReportRow2 = _interopRequireDefault(_paidReportRow);

var _mobile3 = require('./../paid-report-row/mobile');

var _mobile4 = _interopRequireDefault(_mobile3);

var _ad = require('./../paid-report-row/mobile-components/ad');

var _ad2 = _interopRequireDefault(_ad);

var _totalsRow = require('./totals-row');

var _totalsRow2 = _interopRequireDefault(_totalsRow);

var _reportHeader = require('./../report-header');

var _reportHeader2 = _interopRequireDefault(_reportHeader);

var _collaborationCard = require('./../../components/collaboration-card');

var _collaborationCard2 = _interopRequireDefault(_collaborationCard);

var _paidReportTable = require('../../components/paid-report-table');

var _paidReportTable2 = _interopRequireDefault(_paidReportTable);

var _totals = require('../paid-report-row/mobile-components/totals');

var _totals2 = _interopRequireDefault(_totals);

var _utils = require('../basic-report/utils');

var _basicReport = require('../basic-report');

var _csvGenerator = require('../basic-report/csv-generator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_PICKER_DATE_FORMAT = 'DD/MM/YYYY';

var pinkBoldTextStyle = {
  fontWeight: 'bold',
  color: '#fc4085',
  fontSize: 14
};

var pinkIconStyle = {
  color: '#fc4085',
  marginLeft: 10
};

var shortOrder = function shortOrder(text) {
  if (text === 'descending') {
    return 'desc';
  }
  return 'asc';
};

var tableStyle = {
  marginBottom: 0
};

var greenBoldTextStyle = {
  fontWeight: 'bold',
  color: '#20c49e',
  fontSize: 14
};

var greenIconStyle = {
  color: '#20c49e',
  marginLeft: 10
};

var inputStyle = {
  margin: 5
};

var getTotalClicksGI = function getTotalClicksGI(content) {
  var totalClicks = _lodash2.default.sumBy(content, function (c) {
    if (c.finalClicks) {
      return c.finalClicks;
    }
    if (c.type === 'stories') {
      var _$get = _lodash2.default.get(c, 'relationships'),
          data = _$get.supportingData.data;

      var latestSupportingData = _lodash2.default.last(data) || {};
      return _lodash2.default.get(latestSupportingData, 'attributes.clicks') || c.attributes.finalClicks || 0;
    }
    if (c.trackedAsset) {
      var supportingData = c.trackedAsset.supportingData;

      if (supportingData) {
        var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
        var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
          return o.createdDate;
        }));
        var _latestSupportingData = ordered[0];
        return _latestSupportingData ? _latestSupportingData.clicks : 0;
      }
    }
    return 0;
  });
  return totalClicks;
};

var PaidReport = function PaidReport(props) {
  var onFilterChange = props.onFilterChange,
      onOrderChanged = props.onOrderChanged,
      filter = props.filter,
      order = props.order,
      rightFilterOptions = props.rightFilterOptions,
      withHeader = props.withHeader,
      ads = props.ads,
      emptyCampaignText = props.emptyCampaignText,
      reportMode = props.reportMode,
      deleteCallback = props.deleteCallback,
      onDownloadClick = props.onDownloadClick,
      withDaysFilter = props.withDaysFilter,
      withDatePeriodFilter = props.withDatePeriodFilter,
      datePeriodFilterValues = props.datePeriodFilterValues,
      daysOptions = props.daysOptions,
      onPerDaysChanged = props.onPerDaysChanged,
      onDateFilterChange = props.onDateFilterChange,
      perDaysOption = props.perDaysOption,
      emptyCampaignMessageType = props.emptyCampaignMessageType,
      isLoadingMarketingCampaigns = props.isLoadingMarketingCampaigns,
      loadingMarketingCampaignsFailed = props.loadingMarketingCampaignsFailed,
      hasRightFilterOptions = props.hasRightFilterOptions,
      assetOptions = props.assetOptions,
      shouldRenderShareableLinks = props.shouldRenderShareableLinks,
      inGIMode = props.inGIMode;
  var data = props.data.data;
  var name = data.name,
      liveDate = data.liveDate,
      endDate = data.endDate,
      createdBy = data.createdBy,
      posts = data.posts,
      stories = data.stories,
      tiktoks = data.tiktoks,
      hashtags = data.hashtags,
      campaignType = data.campaignType,
      influencer = data.influencer;

  var handleDownloadClick = onDownloadClick || _lodash2.default.noop();
  var processed = _lodash2.default.isEmpty(tiktoks) ? _lodash2.default.compact(posts) : _lodash2.default.concat(_lodash2.default.compact(posts), tiktoks);
  var isACR = campaignType === 'ACR';

  var adsCount = ads ? _lodash2.default.size(ads) : null;
  console.log(adsCount);
  var isEmptyCampaign = _lodash2.default.size(processed) + _lodash2.default.size(stories) === 0;

  var headerInfo = {
    hasLogo: false,
    campaignName: name,
    reportDate: liveDate,
    reportType: 'Campaign report',
    hashtags: hashtags,
    liveDate: liveDate,
    endDate: endDate
  };

  var basicData = null;
  var filename = void 0;
  var timestamp = (0, _moment2.default)().format('YYYY-MM-DD');

  var postsAndStories = processed;
  if (stories && stories.length > 0) {
    _lodash2.default.forEach(stories, function (s) {
      s.publishedDate = s.attributes.publishedDate;
    });
    postsAndStories = _lodash2.default.concat(stories, processed);
  }

  if (filter && filter.platform) {
    postsAndStories = _lodash2.default.filter(postsAndStories, ['trackedAsset.platform', filter.platform]);
  }

  if (filter && filter.discussion) {
    postsAndStories = _lodash2.default.filter(postsAndStories, function (item) {
      return (0, _basicReport.getDiscussionId)(item) === filter.discussion;
    });
  }

  if (order && order.field) {
    postsAndStories = _lodash2.default.orderBy(postsAndStories, function (item) {
      return (0, _basicReport.getOrderField)(item, order.field);
    }, shortOrder(order.value));
  }

  if (data) {
    filename = _lodash2.default.kebabCase(data.name) + '-' + timestamp + '.csv';
    basicData = (0, _csvGenerator.getCsvData)(postsAndStories);
  }

  var channels = (0, _flow2.default)((0, _map2.default)('trackedAsset.platform'), _uniq2.default)(postsAndStories);

  var discussions = _lodash2.default.map(postsAndStories, function (post) {
    return {
      label: (0, _basicReport.getDiscussionLabel)(post),
      value: (0, _basicReport.getDiscussionId)(post)
    };
  });

  var uniqDiscussions = _lodash2.default.uniqBy(_lodash2.default.compact(discussions), 'value');
  var alphaSortedDiscussions = _lodash2.default.orderBy(uniqDiscussions, function (item) {
    return _lodash2.default.lowerCase(_lodash2.default.deburr(item.label));
  }, ['asc']);

  var currentDiscussionName = filter.discussion && _lodash2.default.find(uniqDiscussions, ['value', filter.discussion]).label;

  var totalReach = (0, _utils.getTotalReach)(postsAndStories, inGIMode);
  var totalImpressions = (0, _utils.getTotalImpressions)(postsAndStories, inGIMode);
  var totalLikes = (0, _utils.getTotalLikes)(postsAndStories);

  var paidTotals = (0, _paidReportTable.getPaidTotals)({ data: ads });

  var getAdLikes = function getAdLikes(insightActions) {
    return _lodash2.default.get(_lodash2.default.find(insightActions, function (ia) {
      return ia.action_type === 'post_reaction';
    }), 'value');
  };
  var paidLikes = _lodash2.default.sumBy(ads, function (ad) {
    return _lodash2.default.toNumber(getAdLikes(_lodash2.default.get(ad, 'insights.actions')) || 0);
  });

  console.log('paidLikes', paidLikes);
  console.log('paidLiadskes', ads);

  if (inGIMode && paidTotals) {
    // totalReach = _.add(_.get(paidTotals, 'reach'), totalReach);
    // totalImpressions = _.add(_.get(paidTotals, 'impressions'), totalImpressions);
    totalLikes = _lodash2.default.add(paidLikes, totalLikes);
  }

  var influencerCount = (0, _utils.getInfluencerCount)(postsAndStories);
  var assetCount = (0, _utils.getAssetCount)(postsAndStories);
  var totalViews = (0, _utils.getTotalViews)(postsAndStories);
  var totalShares = (0, _utils.getTotalShares)(postsAndStories);
  var totalComments = (0, _utils.getTotalComments)(postsAndStories);
  console.log('totalComments', totalComments);
  var totalClicks = inGIMode ? getTotalClicksGI(postsAndStories) : (0, _utils.getTotalClicks)(ads);
  var totalEngagements = _lodash2.default.sum([totalLikes, totalShares, totalComments]);
  var orderedPostsAndStories = _lodash2.default.orderBy(postsAndStories, ['publishedDate'], ['desc']);

  var paidEngagements = _lodash2.default.sum([_lodash2.default.get(paidTotals, 'comments', 0), _lodash2.default.get(paidTotals, 'shares', 0), _lodash2.default.get(paidTotals, 'reactions', 0)]);

  var summaryTotals = {
    totalReach: !inGIMode ? _lodash2.default.add(_lodash2.default.get(paidTotals, 'reach'), totalReach) : totalReach,
    totalImpressions: !inGIMode ? _lodash2.default.add(_lodash2.default.get(paidTotals, 'impressions'), totalImpressions) : totalImpressions,
    totalViews: !inGIMode ? _lodash2.default.add(_lodash2.default.get(paidTotals, 'views'), totalViews) : totalViews,
    totalEngagements: !inGIMode ? _lodash2.default.add(totalEngagements, paidEngagements) : totalEngagements
  };

  return _react2.default.createElement(
    'div',
    null,
    withHeader && _react2.default.createElement(
      _semanticUiReact.Card,
      { fluid: true, color: 'pink' },
      _react2.default.createElement(
        _semanticUiReact.Card.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Message,
          { icon: true },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text outline', color: 'pink' }),
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message.Header,
              null,
              name
            ),
            'created by ',
            createdBy
          )
        ),
        _react2.default.createElement(_reportHeader2.default, { info: headerInfo })
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: inGIMode ? 'computer desktop mobile' : 'computer', width: '16' },
          _react2.default.createElement(_paidReportSummary2.default, {
            totalClicks: totalClicks,
            totalReach: summaryTotals.totalReach,
            totalImpressions: summaryTotals.totalImpressions,
            totalEngagements: summaryTotals.totalEngagements,
            influencerCount: influencerCount,
            assetCount: assetCount,
            totalViews: summaryTotals.totalViews,
            adsCount: adsCount,
            inGIMode: inGIMode
          }),
          isACR && _react2.default.createElement(_collaborationCard2.default, influencer),
          _react2.default.createElement(
            _semanticUiReact.Menu,
            null,
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'FILTER BY:'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { scrolling: true, item: true, text: _lodash2.default.lowerCase(filter.platform) || 'platform' },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  filter.platform && _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: onFilterChange,
                      value: 'platform.reset'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
                    'reset'
                  ),
                  _lodash2.default.map(channels, function (channel) {
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        value: 'platform.' + channel,
                        onClick: onFilterChange
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: _lodash2.default.toLower(channel), size: 'tiny' }),
                      ' ',
                      _lodash2.default.toLower(channel)
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { scrolling: true, item: true, text: currentDiscussionName || 'influencer' },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  filter.discussion && _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: onFilterChange,
                      value: 'discussion.reset'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
                    'reset'
                  ),
                  _lodash2.default.map(alphaSortedDiscussions, function (option) {
                    return option.value && _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        onClick: onFilterChange,
                        value: 'discussion.' + option.value
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'tiny' }),
                      ' ',
                      _lodash2.default.toLower(option.label)
                    );
                  })
                )
              )
            ),
            withDatePeriodFilter && _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(_DayPickerInput2.default, {
                component: function component(p) {
                  return _react2.default.createElement(
                    'div',
                    { style: inputStyle, className: 'ui input' },
                    _react2.default.createElement('input', p)
                  );
                },
                onDayChange: function onDayChange(day) {
                  return onDateFilterChange(day, 'start');
                },
                format: DATE_PICKER_DATE_FORMAT,
                dateFormat: DATE_PICKER_DATE_FORMAT,
                placeholder: 'Start date',
                formatDate: _moment3.formatDate,
                parseDate: _moment3.parseDate,
                value: datePeriodFilterValues.start
              }),
              _react2.default.createElement(_DayPickerInput2.default, {
                component: function component(p) {
                  return _react2.default.createElement(
                    'div',
                    { style: inputStyle, className: 'ui input' },
                    _react2.default.createElement('input', p)
                  );
                },
                onDayChange: function onDayChange(day) {
                  return onDateFilterChange(day, 'end');
                },
                format: DATE_PICKER_DATE_FORMAT,
                dateFormat: DATE_PICKER_DATE_FORMAT,
                placeholder: 'End date',
                formatDate: _moment3.formatDate,
                parseDate: _moment3.parseDate,
                value: datePeriodFilterValues.end
              })
            ),
            withDaysFilter && _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { scrolling: true, item: true, text: perDaysOption ? perDaysOption.label : '30 days' },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  _lodash2.default.map(daysOptions, function (option) {
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        key: option.id,
                        onClick: function onClick(e) {
                          return onPerDaysChanged(e, (0, _extends3.default)({}, option));
                        }
                      },
                      _lodash2.default.get(option, 'label', '-')
                    );
                  })
                )
              )
            ),
            withDaysFilter && _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              null,
              _react2.default.createElement(_semanticUiReact.Label, {
                content: 'showing last ' + (perDaysOption ? perDaysOption.label : '30 days') + ' data',
                color: 'orange', basic: true
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              { position: 'right' },
              hasRightFilterOptions && _react2.default.createElement(
                _semanticUiReact.Dropdown,
                {
                  scrolling: true,
                  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus', style: pinkIconStyle }),
                  item: true,
                  basic: true,
                  trigger: _react2.default.createElement(
                    'span',
                    { style: pinkBoldTextStyle },
                    'Add a new asset'
                  )
                },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  _lodash2.default.map(assetOptions, function (option) {
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        onClick: option.onClick,
                        value: option.value
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: option.icon }),
                      option.label
                    );
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { position: 'right', onClick: handleDownloadClick },
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { basic: true, size: 'large', color: 'pink' },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                  _react2.default.createElement(
                    _reactCsv.CSVLink,
                    { data: basicData, filename: filename },
                    'Download Report'
                  )
                )
              ),
              shouldRenderShareableLinks && _react2.default.createElement(_semanticUiReact.Popup, {
                trigger: _react2.default.createElement(
                  _semanticUiReact.Dropdown,
                  {
                    scrolling: true,
                    icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'share', style: greenIconStyle }),
                    item: true,
                    trigger: _react2.default.createElement(
                      'span',
                      { style: greenBoldTextStyle },
                      'shareable reports'
                    )
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Menu,
                    null,
                    _lodash2.default.map(rightFilterOptions, function (option) {
                      return _react2.default.createElement(
                        _semanticUiReact.Dropdown.Item,
                        {
                          value: option.value,
                          onClick: option.onClick
                        },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: option.icon }),
                        option.text
                      );
                    })
                  )
                ),
                content: 'Get links to your shareable reports'
              })
            )
          ),
          isEmptyCampaign && _react2.default.createElement(
            _semanticUiReact.Message,
            {
              icon: true,
              info: _lodash2.default.eq(emptyCampaignMessageType, 'info'),
              warning: _lodash2.default.eq(emptyCampaignMessageType, 'warning')
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
            _react2.default.createElement(
              _semanticUiReact.Message.Content,
              null,
              _react2.default.createElement(
                _semanticUiReact.Message.Header,
                null,
                'Info'
              ),
              emptyCampaignText
            )
          ),
          !isEmptyCampaign && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Card,
              { fluid: true, color: 'green' },
              _react2.default.createElement(
                _semanticUiReact.Card.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Card.Header,
                  null,
                  !inGIMode && 'Organic: ',
                  ' ',
                  name
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Card.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table,
                  {
                    style: tableStyle,
                    sortable: true,
                    singleLine: true,
                    celled: true,
                    fixed: true,
                    basic: 'very',
                    textAlign: 'center'
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Header,
                    null,
                    _react2.default.createElement(_paidReportHeader2.default, {
                      onOrderChanged: onOrderChanged,
                      order: order,
                      withDeleteButton: deleteCallback,
                      inGIMode: inGIMode
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Body,
                    null,
                    _lodash2.default.map(orderedPostsAndStories, function (post) {
                      return _react2.default.createElement(_paidReportRow2.default, {
                        deleteCallback: deleteCallback,
                        viewMode: reportMode,
                        post: post,
                        inGIMode: inGIMode
                      });
                    }),
                    _react2.default.createElement(_totalsRow2.default, {
                      inGIMode: inGIMode,
                      totalReach: totalReach,
                      totalImpressions: totalImpressions,
                      influencerCount: influencerCount,
                      assetCount: assetCount,
                      totalEngagements: totalEngagements,
                      totalViews: totalViews,
                      totalShares: inGIMode ? totalClicks : totalShares,
                      totalComments: totalComments,
                      totalLikes: totalLikes,
                      withDeleteButton: deleteCallback
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Card.Content,
                { extra: true },
                _react2.default.createElement(
                  'div',
                  { className: 'ui right aligned' },
                  'Report generated at ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    (0, _moment2.default)().format('MMMM Do YYYY, h:mm a')
                  ),
                  '.'
                )
              )
            )
          ),
          !inGIMode && _react2.default.createElement(
            'div',
            { style: { marginTop: 50 } },
            _react2.default.createElement(_paidReportTable2.default, {
              title: 'Paid Amplification: ' + name,
              isLoading: isLoadingMarketingCampaigns,
              hasFailedToLoad: loadingMarketingCampaignsFailed,
              data: ads
            })
          )
        ),
        !inGIMode && _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'tablet mobile', width: '16', className: 'mobile-report' },
          _react2.default.createElement(_mobile2.default, {
            totalClicks: totalClicks,
            totalReach: summaryTotals.totalReach,
            totalImpressions: summaryTotals.totalImpressions,
            totalEngagements: summaryTotals.totalEngagements,
            influencerCount: influencerCount,
            assetCount: assetCount,
            totalViews: summaryTotals.totalViews,
            adsCount: adsCount,
            inGIMode: inGIMode,
            inMobileDeviceMode: true
          }),
          _react2.default.createElement(_semanticUiReact.Message, {
            info: true,
            icon: 'line graph',
            header: 'This is the mobile report layout',
            content: 'For full data and features please open the report on desktop or tablet.'
          }),
          _react2.default.createElement(
            _semanticUiReact.Card,
            { fluid: true, color: 'green' },
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              null,
              _react2.default.createElement(
                _semanticUiReact.Card.Header,
                null,
                !inGIMode && 'Organic: ',
                ' ',
                name
              )
            ),
            _lodash2.default.map(postsAndStories, function (asset) {
              return _react2.default.createElement(_mobile4.default, { asset: asset });
            }),
            _react2.default.createElement(_totals2.default, {
              totalReach: totalReach,
              totalImpressions: totalImpressions
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Card,
            { fluid: true, color: 'blue' },
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              null,
              _react2.default.createElement(
                _semanticUiReact.Card.Header,
                null,
                !inGIMode && 'Paid Amplification: ',
                ' ',
                name
              )
            ),
            _lodash2.default.map(ads, function (ad) {
              return _react2.default.createElement(_ad2.default, { item: ad });
            }),
            _react2.default.createElement(_totals2.default, {
              totalReach: paidTotals.reach,
              totalImpressions: paidTotals.impressions,
              totalEngagements: paidEngagements
            })
          )
        )
      )
    )
  );
};

PaidReport.propTypes = {
  inGIMode: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    createdBy: _propTypes2.default.string.isRequired,
    posts: _propTypes2.default.arrayOf(_propTypes2.default.object)
  }).isRequired,
  onFilterChange: _propTypes2.default.func.isRequired,
  onOrderChanged: _propTypes2.default.func.isRequired,
  filter: _propTypes2.default.object.isRequired,
  order: _propTypes2.default.object.isRequired,
  withHeader: _propTypes2.default.bool.isRequired,
  rightFilterOptions: _propTypes2.default.array.isRequired,
  hasRightFilterOptions: _propTypes2.default.bool.isRequired,
  emptyCampaignText: _propTypes2.default.string.isRequired,
  reportMode: _propTypes2.default.string.isRequired,
  deleteCallback: _propTypes2.default.func.isRequired,
  withDaysFilter: _propTypes2.default.bool,
  withDatePeriodFilter: _propTypes2.default.bool,
  datePeriodFilterValues: _propTypes2.default.object,
  onDateFilterChange: _propTypes2.default.func,
  daysOptions: _propTypes2.default.array,
  onPerDaysChanged: _propTypes2.default.func,
  perDaysOption: _propTypes2.default.object,
  hasMarketingCampaigns: _propTypes2.default.bool,
  ads: _propTypes2.default.array,
  shouldRenderShareableLinks: _propTypes2.default.bool
};

PaidReport.defaultProps = {
  inGIMode: false,
  withHeader: false,
  hasRightFilterOptions: true,
  emptyCampaignText: 'No posts included in this campaign',
  emptyCampaignMessageType: 'info',
  reportMode: 'external',
  withDaysFilter: false,
  withDatePeriodFilter: false,
  onDateFilterChange: _lodash2.default.noop,
  datePeriodFilterValues: {
    start: new Date(),
    end: new Date()
  },
  daysOptions: [],
  perDaysOption: null,
  deleteCallback: null,
  onPerDaysChanged: function onPerDaysChanged() {
    return _lodash2.default.noop;
  },
  hasMarketingCampaigns: false,
  ads: [],
  shouldRenderShareableLinks: true
};

exports.default = PaidReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/paid-report/index.js
// module id = 1797
// module chunks = 1